import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import Icon, { IconTypes } from 'components/basic/Icon';
import { BodyL } from 'components/basic/Typography';

import s from './LearnMoreLink.module.scss';

interface Props {
  header: string;
  subHeader?: string;
  href: string;
  className?: string;
}

const LearnMoreLink: FC<Props> = ({ header, href, subHeader, className }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cn(s.wrapper, className)}
    >
      <div className={s.textWrapper}>
        <Icon
          icon={IconTypes.book}
          size={32}
          className={s.icon}
          color="white_70"
        />
        <BodyL>{header}</BodyL>
      </div>
      {subHeader && <BodyL className={s.subheader}>{subHeader}</BodyL>}
    </a>
  );
};

export default LearnMoreLink;
